export default __webpack_public_path__ + "static/media/Abdomen.891744b0.svg";